import {ITeamRole} from './organization-team.enum';

export enum API_URL {
  //auth
  ORGANIZATION_LOGIN = 'Auth/login/organization',
  REFRESH_TOKEN = 'Auth/refresh',
  FORGOT_PASSWORD = 'Auth/password/forgot',

  //auth user
  USER_LOGIN = 'Auth/login/user',
  USER_CREATE = 'User/register',
  GOOGLE_LOGIN = 'Auth/login/google/organization',
  GOOGLE_ORGANIZATION_REGISTER = 'Auth/register/google/organization',
  APPLE_ORGANIZATION_SIGNUP_PREPARE = 'Auth/register/apple/organization/prepare',
  APPLE_ORGANIZATION_REGISTER = 'Auth/register/apple/organization',
  USER_GOOGLE_LOGIN = 'Auth/login/google/user',
  APPLE_LOGIN = 'Auth/login/apple/organization',
  USER_APPLE_LOGIN = 'Auth/login/apple/user',

  //Change Password
  VERIFY_OLD_PASSWORD = 'Auth/password/verify',
  SET_NEW_PASSWORD = 'Auth/password/set',
  RECOVER_PASSWORD = 'Auth/password/recover',

  //user
  USER_INFO = 'User',
  USER_INFO_START_CARD_ATTACHMENT = 'User/me/payment-method/setup-sessions',

  //organization
  ORGANIZATION_CREATE = 'Organization/register',
  ORGANIZATION_INFO = 'Organization',
  ORGANIZATION_PRESIGN_AVATAR = 'Organization/presignedUrl',

  //events
  EVENT = '/Event',
  GET_EVENTS = '/Organization/events',
  EVENT_TODO_LIST = '/Event/toDoList',
  EVENT_SPONSOR_CATEGORIES = '/Event/sponsorCategories',
  PRESIGNED_EVENT_IMAGE = '/Event/presignedUrl',
  PRESIGNED_SPONSOR_IMAGE = '/Event/sponsor/presignedUrl',
  EVENT_SPONSOR = '/Event/sponsor',
  EVENT_TODO_ITEM = '/Event/toDoItem',
  EVENT_BY_SLUG = '/Event/BySlug',
  ADD_SPONSOR_CATEGORY = '/Event/addSponsorCategory',

  //dashboard
  DASHBOARD_STATISTICS = 'Dashboard/statistics',
  DASHBOARD_TABLES_SOLD = 'Dashboard/tablesSold',
  DASHBOARD_EXPORT_TABLES_SOLD = 'Dashboard/export/tablesSold',
  DASHBOARD_UNKNOWN_GUESTS = 'Dashboard/unknownGuests',
  DASHBOARD_EXPORT_UNKNOWN_GUESTS = 'Dashboard/export/unknownGuests',
  DASHBOARD_AUCTION_ITEMS = 'Dashboard/items',
  DASHBOARD_EXPORT_AUCTION_ITEMS = 'Dashboard/export/items',
  DASHBOARD_CHECKED_IN = 'Dashboard/checkedIn',
  DASHBOARD_EXPORT_CHECKED_IN = 'Dashboard/export/checkedIn',
  DASHBOARD_SPECIAL_MEALS = 'Dashboard/specialMeals',
  DASHBOARD_EXPORT_SPECIAL_MEALS = 'Dashboard/export/specialMeals',
  DASHBOARD_ATTENTION = 'Dashboard/attention',

  //tables and tickets
  TABLES_AND_TICKETS = 'TableAndTicket',
  TABLES_AND_TICKETS_TABLE = 'TableAndTicket/table',
  TABLES_AND_TICKETS_TICKETS_LIST = 'TableAndTicket/ticketsList',
  TABLES_AND_TICKETS_TIERS = 'TableAndTicket/tiers',
  TABLES_AND_TICKETS_STATISTICS = 'TableAndTicket/statistics',
  TABLES_AND_TICKETS_AVAILABLE_TICKETS = 'TableAndTicket/availableTickets',
  TABLES_AND_TICKETS_AVAILABLE_TICKETS_EXPORT = 'TableAndTicket/export/availableTickets',
  TABLES_AND_TICKETS_MAKE_DONATION = 'TableAndTicket/donation',
  TABLES_AND_TICKET_UPDATE_STATUS = 'TableAndTicket/updateStatus',
  TABLES_AND_TICKET_PREPARE_CHECKOUT = 'TableAndTicket/prepare-checkout',

  //Donation
  DONATION = 'Donation',
  EVENT_DONATION_LIST = 'Donation/event',

  //auction
  AUCTION = 'Item',
  AUCTION_CREATE = 'Item/create',
  AUCTION_CATEGORY = 'Item/itemCategory',
  AUCTION_DONOR = 'Item/donor',
  AUCTION_ACTIVE_TIME = 'Item/getAuctionTime',
  AUCTION_WON_ITEMS = 'Item/winningItems',

  //Bid
  BIDS = 'Bid/getBidsForItem',
  BIDS_FOR_BIDDER = 'Bid/getBidsForBidder',
  CREATE_BID = 'Bid/create',
  BUY_ITEM = 'Bid/buyNow',
  ADD_WINNER = 'Bid/winner',

  //attendee
  ATTENDEE = 'Attendee',

  ATTENDEE_STATISTICS = 'Attendee/statistics',
  ATTENDEE_VIP = 'Attendee/vip',
  ATTENDEE_STATUS = 'Attendee/status',
  ATTENDEE_ACCOUNT = 'Attendee/account',
  UPDATE_ATTENDEE_FROM_CONTACT_LIST = 'Attendee/updateFromContactList/event',
  ATTENDEE_DUPLICATES = 'Attendee/duplicates',

  //contact
  CONTACT = 'Contact',
  CONTACT_LIST = 'Contact/filteredList',
  CONTACT_LIST_GET_EXISTING = 'Contact/existingContacts',

  //notification settings
  VIP_PHONES = 'NotificationSetting/VIPNumbers',
  VIP_PHONE = 'NotificationSetting/VIPnumber',
  NOTIFICATION_SETTING = 'NotificationSetting/organization',

  //notifications
  NOTIFICATION = 'Notification',
  NOTIFICATION_UPDATES = 'Notification/markAllAsRead',
  NOTIFICATION_ONE_UPDATES = 'Notification/markAsRead',

  //user notification settings
  USER_NOTIFICATION_SETTING = 'NotificationSetting/user',

  //organization team
  TEAM_GENERATE_PASSWORD = 'Team/password',
  CREATE_TEAM_MEMBER = 'Team/create',
  TEAM = 'Team',
  TEAM_PRESIGN_IMAGE = 'Team/logo/presignedUrl',
  TEAM_RESEND_INVITE = 'Team/resend',

  //presignItemImage
  PRESIGN_IMAGE = 'Item/presignedUrls',

  //superadmin
  SUPER_ADMIN_LOGIN = 'Auth/login/admin',
  SUPER_ADMIN_INFO = 'Admin',
  ADMIN_NOTIFICATION_SETTING = 'NotificationSetting/admin',
  ADMIN_ALL_ORGANIZATIONS = 'SuperAdminOrg/getOrganizationsList',
  ADMIN_ORGANIZATION_BY_ID = 'SuperAdminOrg/orgInfoById',
  ADMIN_ORGANIZATION_TRANSACTIONS = 'AdminDashboard/transactions',
  ADMIN_ALL_EVENTS = 'Event/filter',
  ADMIN_STATISTIC = 'AdminDashboard/statistics',
  ADMIN_STATUS_UPDATE = 'SuperAdminOrg/updateActiveStatus',
  ADMIN_ORG = 'SuperAdminOrg',
  ADMIN_PLATFORM_FEE = 'Admin/platform-fee',
  ADMIN_2FACTOR_STATUS = 'admin/2fa/status',
  ADMIN_2FACTOR_SETUP = 'admin/2fa/setup',
  ADMIN_2FACTOR_CONFIRM = 'admin/2fa/confirm',
  ADMIN_2FACTOR_DISABLE = 'admin/2fa/disable',
  SUPER_ADMIN_LOGIN_2FACTOR = 'Auth/login/admin/2fa',

  //presignItemImage Donor
  PRESIGN_IMAGE_DONOR = 'Item/donor/presignedUrl',

  //reports
  REPORT_UNPAID_ITEMS = 'Report/unpaidItems',
  REPORT_UNPAID_TABLES = 'Report/unpaidTables',
  REPORT_PARTICIPANTS = 'Report/participants',
  REPORT_MAX_BIDS = 'Report/valueOfMaxBids',
  REPORT_GET_FILE_UNPAID_ITEMS = 'Report/export/unpaidItems',
  REPORT_GET_FILE_UNPAID_TABLES = 'Report/export/unpaidTables',
  REPORT_GET_FILE_PARTICIPANTS = 'Report/export/participants',
  REPORT_GET_FILE_MAX_BIDS = 'Report/export/valueOfMaxBids',
  REPORT_GET_FULL_REPORT = 'Report/fullReport',
  REPORT_GET_FULL_REPORT_COLUMNS = 'Report/attendeeFinancial/columns',
  REPORT_GET_ATTENDEE_FINANCIAL_REPORT = 'Report/attendeeFinancial',
  REPORT_GET_FILE_ATTENDEE_FINANCIAL_REPORT = 'Report/attendeeFinancial/export',

  //communication
  CREATE_CUSTOMIZATION_TEMPLATE = 'Email/saveCustomization',
  GET_PRESIGNED_CUSTOMIZATION_TEMPLATE_IMAGE = 'Email/presignedUrl',
  GET_CUSTOMIZATION_TEMPLATES = 'Email/customization',
  SEND_CUSTOMIZATION_EMAIL = 'Email/customizationEmail',
  GET_All_TEMPLATES_TYPES = 'Email/templates/metadata',
  GET_All_TEMPLATES = 'Email/templates',

  SEND_EMAIL_TEMPLATE = 'Email/send',
  SEND_TEST_EMAIL_TEMPLATE = 'Email/test',
  SEND_TICKET_INVOICE_EMAIL = 'Email/ticketInvoiceEmail',
  SEND_TICKET_PAYMENT_CONFIRMATION = 'Email/ticketPaymentEmail',
  SEND_INVOICE_EMAIL = 'Email/invoiceEmail',
  SEND_WINNERS_EMAIL = 'Email/notifyWinners',
  SEND_ATTENDEE_TICKET = 'Email/attendeeTicket',
  SEND_ATTENDEE_RECEIPT = 'Email/attendeeReceipt',

  //printable
  GET_WEBSITE_QR_CODE = 'Printtable/WebsiteQrcode',
  GET_BIG_SHEET_ITEM = 'Printtable/GenerateBidSheetPdf',
  GET_PDF_GUEST_LIST = 'Printtable/guestlist',
  GET_PRINTTABLE_TEMPLATE = 'Printtable/customization',
  PRESIGN_PRINTTABLE_TEMPLATE = 'Printtable/customization/presigned-url',

  //payment
  GET_ATTENDEE_AUCTION_CONTRIBUTIONS = 'Payment/attendee',
  PAYMENT = 'Payment',
  PAYMENT_BILLING_HISTORY = 'Payment/billing-history',
}
export const updateMemberRole = (id: number, role?: ITeamRole) => `Team/${id}/role?role=${role}`;
